export default "https://cdn-static.gokick.com/assets/e693edcab6ba034c0ea6bea85be7a795ed1fbf27/images/spearmint-flavor.30903ab4672f84579e06d9b02d9a9cc8.png";